import { render, staticRenderFns } from "./NextHopGroupForm.vue?vue&type=template&id=a486919e&"
import script from "./NextHopGroupForm.vue?vue&type=script&lang=js&"
export * from "./NextHopGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports